/**
 * Atividades padrão do sistema (importadas do tenant base a2-aquatica-001).
 * Gerado automaticamente por scripts/convertActivities.js
 */
export const DEFAULT_ACTIVITIES = [
    {
        "color": "#a1c9f1",
        "name": "Baby 1",
        "searchName": "baby 1",
        "description": "Aqui a diversão começa! 💦 Na primeira aventura na água, os bebês aprendem a perder o medo, brincam de fazer bolhas, dão pulinhos corajosos e descobrem como é legal flutuar com a ajuda do professor. Tudo com muita música e estímulos lúdicos!",
        "order": 0,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 14,
        "value": 0,
        "objectives": [
            {
                "id": "9cc8907f-205e-4b50-86ea-ed39c6a5bcd7",
                "name": "Mergulho com bloqueio da respiração",
                "order": 1,
                "xp": 2,
                "topics": [
                    {
                        "id": "3c05f8a7-ffba-41b1-8890-3a00d832f035",
                        "name": "Aceita respingos na cabeça e no rosto sem se assustar",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "0b38f901-2b2f-4851-b0ae-86dcc3bfcd31",
                        "name": "Consegue imergir com auxílio do professor (curtos mergulhos guiados).",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "b7644231-9202-4214-a3e4-36d5420585df",
                "name": "Flutuação",
                "order": 2,
                "xp": 2,
                "topics": [
                    {
                        "id": "0464eed8-121e-4fef-90ff-d4e55656694e",
                        "name": "Consegue flutuar com apoio de cabeça (professor ou responsável).",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "0028709f-1c63-485e-b357-3909e09eaadc",
                        "name": "Consegue flutuar sozinho, utilizando material flutuante.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "3a3792f0-5206-4ff0-b064-981749d77dee",
                "name": "Movimentação de braços e pernas",
                "order": 3,
                "xp": 4,
                "topics": [
                    {
                        "id": "14fade28-64c7-4dfc-93c1-143f3c4f16e2",
                        "name": "Movimenta braços com apoio nas axilas (professor ou responsável).",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "bf39b4ff-f206-4790-adfb-fb209ea14832",
                        "name": "Movimenta pernas com apoio nas axilas.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "b63b999d-831f-4b2e-afa7-9d9a42f81709",
                        "name": "Movimenta braços e pernas com o rosto na água, com ajuda.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "56d1bdf5-d66e-4408-bd9e-8195eb80cb9f",
                        "name": "Movimenta braços e pernas sem auxílio, ainda que por poucos segundos.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "75b727e9-effd-447a-b215-df926d8f1d76",
                "name": "Salto",
                "order": 4,
                "xp": 4,
                "topics": [
                    {
                        "id": "fbe55a6d-cadf-400c-b513-44df65b45d62",
                        "name": "Respeita o comando do professor para o momento do salto.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "6101141c-330e-4ee1-90c4-7a100eca6e9d",
                        "name": "Salta para frente, em posição sentada, buscando horizontalizar o corpo, com auxílio.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "17ee490d-3a86-4061-a76f-8e85c6764a54",
                        "name": "Submerge e retorna à superfície com auxílio do professor ou responsável.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "b6d0a0f1-c922-4aaf-95cc-82330e50a803",
                        "name": "Salta e executa movimentação de braços e pernas em direção ao professor ou responsável (curta distância).",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "8e9906cc-fa93-4a55-ab13-2b5f1db3f2f0",
                "name": "Objetivos complementares",
                "order": 5,
                "xp": 2,
                "topics": [
                    {
                        "id": "0269914f-c95e-409b-965b-e822e2e77d6d",
                        "name": "Interage com outras crianças em brincadeiras aquáticas.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "0c9e6c40-1ac4-4605-aa9a-002e3d0f6964",
                        "name": "Realiza movimentos simples guiados por músicas, palmas e ritmos.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            }
        ]
    },
    {
        "color": "#c3edc0",
        "name": "Baby 2",
        "searchName": "baby 2",
        "description": "Nossos peixinhos estão crescendo! 🐠 Agora a brincadeira fica mais animada: eles já soltam bolhas sozinhos, buscam tesouros no fundo da piscina e flutuam como estrelinhas-do-mar. Os saltos ganham mais segurança e as pernadas já começam a levá-los para pequenos passeios.",
        "order": 1,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 26,
        "value": 0,
        "objectives": [
            {
                "id": "eb4f823a-cbaf-4dc7-ad60-0a2cc88c6811",
                "name": "Mergulho com bloqueio da respiração",
                "order": 1,
                "xp": 5,
                "topics": [
                    {
                        "id": "e3480ea3-e845-4c34-b450-b0105a602b90",
                        "name": "Consegue imergir sem auxílio direto do professor",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "9546aed9-dff8-4965-9320-d75860041d77",
                        "name": "Faz expiração ao mergulhar (faz bolhas na água).",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "555cce81-188d-4153-abf4-fd8ecda47d5f",
                        "name": "Consegue pegar objetos no fundo da piscina, com auxílio (profundidade adequada à idade).",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "5b61460c-13ae-496f-8f97-c31315a68fbf",
                "name": "Flutuação",
                "order": 2,
                "xp": 6,
                "topics": [
                    {
                        "id": "f8b7cc1b-3efe-4f5c-a5af-1f62ad3cb89d",
                        "name": "Flutua sozinho com auxílio de material flutuante (decúbito dorsal).",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "4791b06d-5adc-4cb8-bf0a-93efdcccfea5",
                        "name": "Flutua sozinho, sem material (decúbito dorsal).",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "34d25ca3-3b6e-4dc8-bc63-5e7ddb9e96b7",
                        "name": "Flutua sozinho com auxílio de material flutuante (decúbito ventral).",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "e1580b23-d38a-4de7-b6fa-4d378b5a68c4",
                        "name": "Flutua sozinho, sem material (decúbito ventral).",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "a6e8463b-a2d1-44a4-90b6-c40447e1de2f",
                "name": "Movimentação de braços e pernas",
                "order": 3,
                "xp": 9,
                "topics": [
                    {
                        "id": "b3d04588-4941-4be8-b620-a98882716284",
                        "name": "Realiza movimentação de braços sem auxílio.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "27807ba0-8976-47dd-8b97-ece458263f4f",
                        "name": "Realiza movimentação de pernas sem auxílio.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "bb2f91ea-1833-4e02-a11f-22c1d1a93ccc",
                        "name": "Movimenta braços e pernas com o rosto na água, sem auxílio, produzindo pequeno deslocamento.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "1ba15519-0d1c-4c6b-9943-7062c9a816c1",
                "name": "Salto",
                "order": 4,
                "xp": 6,
                "topics": [
                    {
                        "id": "9828af38-ce1a-461e-8a64-8d548d679616",
                        "name": "Respeita o comando para o salto.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "4f3ed75e-95e9-4e08-b08f-4c3d6da32385",
                        "name": "Salta para frente (buscando horizontalizar o corpo), sem auxílio.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "d935ff1b-93f7-414c-a94d-13a3837167ce",
                        "name": "Submerge após o salto, sem auxílio, retornando à superfície com independência.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "c4872453-2645-4029-93b7-12bae8db35b6",
                        "name": "Salta e executa movimentação de braços e pernas em direção ao professor ou responsável (curta distância).",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            }
        ]
    },
    {
        "color": "#c9d9f2",
        "name": "Estágio 1",
        "searchName": "estagio 1",
        "description": "Hora de construir a confiança de um super nadador! 🦸‍♂️ No Estágio 1, a criançada aprende grandes superpoderes: respirar certinho embaixo d'água, flutuar nas duas posições e coordenar as primeiras braçadas de sobrevivência e do nado Cachorrinho. Muita brincadeira e aprendizado!",
        "order": 2,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 42,
        "value": 0,
        "objectives": [
            {
                "id": "cd33232e-600a-4668-90a4-cfed34153d36",
                "name": "Controle respiratório",
                "order": 1,
                "xp": 9,
                "topics": [
                    {
                        "id": "890c2196-1dd6-42b1-b818-09b9d3ac48ec",
                        "name": "Faz bolhas ao mergulhar, de forma contínua.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "672ca888-e792-43b7-b057-43b2ca7efeee",
                        "name": "Alternada expiração pela boca e pelo nariz.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "99318a7d-3c6b-4dda-8518-6420341d27b4",
                        "name": "Inspira pela boca e expira pelo nariz, com ritmo.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "44546c2b-c414-4cfc-8d9a-f6f816c504ee",
                "name": "Flutuação",
                "order": 2,
                "xp": 9,
                "topics": [
                    {
                        "id": "84cf2aaf-9dd7-4036-bdfd-2ea0cc94c9b6",
                        "name": "Faz flutuação em decúbito dorsal de forma estável.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "2923dc66-ca17-4c09-85b1-f1c10fa4229f",
                        "name": "Faz flutuação em decúbito ventral, com rosto na água.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "9e5967fb-d891-4bbe-81fe-357d32e414d8",
                        "name": "Alternada flutuação ventral/dorsal (vira de barriga para cima e para baixo na água).",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "8f9b962a-544e-4655-902c-60cfd6a5f66a",
                "name": "Deslize",
                "order": 3,
                "xp": 8,
                "topics": [
                    {
                        "id": "7559a5ed-3afd-43be-b9e3-2a5175bee682",
                        "name": "Desliza na posição ventral em flecha (streamline).",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "6ce8de22-776c-45de-8258-57a65935c455",
                        "name": "Desliza na posição dorsal em flecha.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "e6685918-5df3-455f-8b4e-2cc89f73d5d6",
                        "name": "Desliza após o salto ou impulso da parede.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "59b073a8-4551-4f8f-bb71-9b21daaadf7f",
                        "name": "Remonta à posição em pé após o deslize, sem auxílio.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "6bf8869d-8e53-4589-9d83-3e9f427d5f29",
                "name": "Pernada de crawl",
                "order": 4,
                "xp": 6,
                "topics": [
                    {
                        "id": "195554f7-1d5b-4bfb-acae-64eda5ed6785",
                        "name": "Faz pernada de crawl com deslocamento utilizando material (prancha ou similar).",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "c894ff2b-0536-4f20-8a54-053cc58dfc7f",
                        "name": "Faz pernada de crawl com deslocamento sem auxílio de material, mantendo ritmo.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "8b68af18-9bd5-452f-b606-3b1e7f193138",
                "name": "Braçada de crawl",
                "order": 5,
                "xp": 2,
                "topics": [
                    {
                        "id": "9f2b9080-ea40-45c4-a2d9-b535627553d3",
                        "name": "Faz braçada de crawl com deslocamento utilizando apoio de material, focando no \"puxar a água\".",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "2826369c-cf78-42cd-8f66-e9bfc8c1df9f",
                        "name": "Faz braçada de crawl com deslocamento sem material, mantendo o trajeto da mão na água.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "370a4c56-af6a-4e31-af2b-0a00f7a6ec05",
                "name": "Coordenação de crawl",
                "order": 6,
                "xp": 2,
                "topics": [
                    {
                        "id": "c437ed06-ee46-4d8a-8481-7d8f4cdfe298",
                        "name": "Coordena movimentos de braçada e pernada de crawl em pequenos percursos.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "0d47c510-0c2d-420f-8e07-ca3344478e83",
                        "name": "Coordena braçada, pernada e respiração de crawl, ainda que com pequenas pausas.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "939de9ec-6f7b-4695-86b8-7b3ca31d9239",
                "name": "Saída de crawl",
                "order": 7,
                "xp": 3,
                "topics": [
                    {
                        "id": "e57e5f37-8b84-457c-8ebf-0d520f7fa794",
                        "name": "Faz a saída de crawl a partir da posição sentada, com corpo horizontalizado.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "4ddf5c1b-9307-4029-a781-415fa363ae31",
                        "name": "Realiza posição streamline (braços estendidos à frente e pernas estendidas) após o salto ou impulso.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "17558204-f595-47a7-b6ab-67adc5ca6546",
                        "name": "Conecta a saída ao nado, transformando o deslize nos primeiros ciclos de crawl.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "690ab54b-370c-4cbe-9b52-0a1324bbff8f",
                "name": "Nado de sobrevivência",
                "order": 8,
                "xp": 1,
                "topics": [
                    {
                        "id": "39cd9aad-2adb-4d19-8ab0-176fa13b2382",
                        "name": "Após o salto, consegue retornar à borda sem auxílio (cerca de 5 m), utilizando qualquer forma de deslocamento ensinada.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "5c18451d-bf93-4be2-8f92-c6ac69ea365d",
                "name": "Pernada de costas",
                "order": 9,
                "xp": 2,
                "topics": [
                    {
                        "id": "aa53a525-076c-4b56-ba94-7a4934a67889",
                        "name": "Faz pernada de costas com auxílio de material (prancha ou flutuador).",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "178e414a-d947-4a18-98a6-b5066523ae5a",
                        "name": "Faz pernada de costas sem auxílio de material, mantendo quadril próximo à superfície.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            }
        ]
    },
    {
        "color": "#fff2a2",
        "name": "Estágio 2",
        "searchName": "estagio 2",
        "description": "Já nadamos como golfinhos! 🐬 No Estágio 2, os movimentos ficam mais bonitos e organizados. Nossa turma aprende a nadar o Crawl e o nado de Costas direitinho, além de dar os primeiros pulos em flecha e descobrir os segredinhos da pernada do sapinho (Peito) e da ondinha do Borboleta!",
        "order": 3,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 35,
        "value": 0,
        "objectives": [
            {
                "id": "f0bb122c-a8cc-408c-9cef-7d7604ea561d",
                "name": "Nado crawl – aperfeiçoamento da pernada",
                "order": 1,
                "xp": 3,
                "topics": [
                    {
                        "id": "4ddc2624-eed3-4517-ab42-45a1335ded13",
                        "name": "Realiza pernada de crawl com prancha: movimento alternado e contínuo, iniciando no quadril e terminando nos pés em flexão plantar.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "d541f6f4-5242-4f26-b4d5-d2544f8372d3",
                        "name": "Executa pernada de crawl sem prancha: movimentos curtos, verticais/diagonais, próximos à superfície, mantendo o corpo alinhado.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "4ae16fc2-08a3-471c-abed-ce2d84a1b7e5",
                        "name": "Mantém ritmo constante de pernada durante todo o percurso, sem interromper nas respirações.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "0d3454c7-f06b-4a73-89d2-860fc20ce6e0",
                "name": "Nado crawl – braçada e respiração",
                "order": 2,
                "xp": 3,
                "topics": [
                    {
                        "id": "7c12f6c1-2cc6-47c3-899e-92cd66e4a868",
                        "name": "Realiza braçada alternada com apoio (prancha ou material), empurrando a água para trás com eficiência.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "cbc1a758-485a-45a2-9fdc-99671bb3008d",
                        "name": "Sincroniza braços e respiração: retira o rosto lateralmente no final da braçada, inspira na recuperação e expira com o rosto na água.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "7d8f8fc9-e9a5-4da3-9a81-f5ad913a6177",
                        "name": "Mantém rotação suave de tronco, evitando levantar a cabeça para respirar.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "e092f558-2215-4167-9569-c26accaef7f3",
                "name": "Nado crawl – nado completo",
                "order": 3,
                "xp": 3,
                "topics": [
                    {
                        "id": "beaa0a65-9ea9-4e50-8780-843de9abf24d",
                        "name": "Coordena pernada, braçada e respiração em deslocamentos curtos (meia raia, por exemplo).",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "85dde38c-1ead-45fc-abe2-a070391e909b",
                        "name": "Realiza nado completo de crawl com pequeno deslizamento entre as braçadas (pegada dupla), evitando braçada corrida.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "ec8938c9-8d2e-4e51-a3f7-7d62555289f1",
                        "name": "Consegue nadar uma distância-alvo definida pela escola (ex.: 12,5 m ou 25 m) mantendo padrão técnico estável.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "475e6948-866f-4ad1-bb9a-fd7ac6a3c557",
                "name": "Nado costas – posição e pernada",
                "order": 4,
                "xp": 7,
                "topics": [
                    {
                        "id": "d619971f-cd58-4742-8ee9-e415480539b7",
                        "name": "Mantém decúbito dorsal estável: orelhas dentro da água, olhar para cima e quadril próximo à superfície.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "4fc2c8b0-de54-48d7-b0ca-bbe21560f336",
                        "name": "Executa pernada de costas com braços ao longo do corpo: movimento alternado e contínuo.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "ac0e0dc2-3fe2-400b-a77b-b7f19774139e",
                        "name": "Mantém movimentos curtos de pernada, próximos à superfície, sem \"chutar fora d'água\".",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "c59e9681-da5c-40d8-b5e6-2d8a455eea6b",
                "name": "Nado costas – braçada e nado completo",
                "order": 5,
                "xp": 7,
                "topics": [
                    {
                        "id": "0562bfad-7ac7-4af0-a6d6-aa53baf01af6",
                        "name": "Realiza braçada alternada de costas (podendo usar prancha sobre a coxa): saída da água com o polegar e entrada com o dedo mínimo.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "2b937636-5454-46dd-9c72-839f7760bb19",
                        "name": "Sincroniza braçada e respiração em costas, respirando de forma contínua e confortável.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "39f7ad9a-d1c3-4ecf-8416-6e9cf44fbba7",
                        "name": "Executa nado completo de costas, coordenando pernada e braçada alternadas em todo o percurso.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "45541dd8-79e1-4df8-b71e-f42905dbd86d",
                "name": "Saídas (largadas) e mergulhos",
                "order": 6,
                "xp": 2,
                "topics": [
                    {
                        "id": "83c3ffcc-699a-4dee-8191-2180fdaf9625",
                        "name": "Faz impulsão da parede em posição ventral: sai em flecha (streamline) em deslize submerso seguido de pernada de crawl.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "f801c2eb-1258-4611-b6b0-bb06e382c4ec",
                        "name": "Faz impulsão da parede em posição dorsal: sai em flecha na superfície, iniciando pernada de costas.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "70f23e59-3d11-4616-ad98-761e083cad46",
                "name": "Chegadas – crawl e costas",
                "order": 7,
                "xp": 2,
                "topics": [
                    {
                        "id": "e5f10f1c-b205-4a57-b1b3-0c7f1a8458bc",
                        "name": "Em crawl, aproxima-se da borda mantendo velocidade, ajusta a sequência de braçadas e finaliza com toque firme da mão na borda.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "fb5a8019-d101-42dc-ac9d-b9e549e6d05f",
                        "name": "Em costas, mantém o nado até a borda, controlando a aproximação e finalizando com toque controlado, sem virar de bruços antes da chegada.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "0c4ad793-a17c-403c-9c36-13bc7bd29fa8",
                "name": "Pernada de peito – iniciação",
                "order": 8,
                "xp": 4,
                "topics": [
                    {
                        "id": "d45e79a4-651a-48af-b722-70b34a44aa35",
                        "name": "Com prancha, flexiona joelhos levando os calcanhares em direção aos glúteos.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "441d242e-4023-413e-82ad-aca6e98e0e05",
                        "name": "Aprende a sequência básica da pernada de peito: flexionar, abrir/empurrar e estender.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "9fc3cd69-3ae3-4f1c-8d65-37b821a99e25",
                        "name": "Empurra a água com a sola dos pés para fora e para trás, produzindo deslocamento visível.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "7c52382c-5bdb-4433-b52e-172e65372c42",
                        "name": "Mantém a pernada de peito ritmada em pequenos percursos, mesmo que combinada com braçadas simples ou apoio na prancha.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "fe5e2ebd-2117-4da1-a85b-a6370e0b679c",
                "name": "Pernada de borboleta – iniciação",
                "order": 9,
                "xp": 4,
                "topics": [
                    {
                        "id": "a53b3bc0-0627-49ac-a191-dc679facba09",
                        "name": "Com prancha à frente, realiza ondulação básica do corpo, iniciando o movimento no quadril.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "311bfd42-d6a6-4ef7-bef1-835192f1cefe",
                        "name": "Executa pernadas simultâneas para cima e para baixo, sentindo o corpo \"ondular\" na água.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "d143638e-625d-4f3b-a826-c6ab0c2d85ed",
                        "name": "Empurra a água com o dorso dos pés, mantendo pernas relativamente unidas.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "89e4e11e-bced-465c-8b0b-58d3c6030af7",
                        "name": "Mantém ritmo contínuo de pernada de borboleta em pequenos deslocamentos, ainda sem exigência de braçada de borboleta.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            }
        ]
    },
    {
        "color": "#d1c4e9",
        "name": "Estágio 3",
        "searchName": "estagio 3",
        "description": "Aventura acelerada na água! 🌊 Aqui os nadadores afinam seus poderes no Crawl e Costas, e aprendem o nado Peito completinho! A diversão aumenta quando eles começam a fazer aquela cambalhota super legal da virada olímpica e os pulos submersos caprichados.",
        "order": 4,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 71,
        "value": 0,
        "objectives": [
            {
                "id": "f8fc6eba-415a-4bd2-8e6a-cd596991d418",
                "name": "Nado crawl – aperfeiçoamento avançado",
                "order": 1,
                "xp": 9,
                "topics": [
                    {
                        "id": "7e0d14b9-58a3-4933-a930-c0aec59a42b8",
                        "name": "Mantém corpo alinhado, com cabeça estável e olhar levemente à frente.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "a690e519-4a3a-487b-9559-82e248c95fac",
                        "name": "Realiza braçada de crawl com boa pegada de água, puxando e empurrando até o fim.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "bbbaf89a-4303-41bc-8e0e-4f38fee53be2",
                        "name": "Mantém pernada contínua e ritmada, ajustando o número de pernadas por ciclo.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "aeaeeceb-00ec-43e4-93d6-c4f9714231b7",
                        "name": "Coordena braçada, pernada e respiração com fluidez, sem pausas bruscas.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "0f4f0673-1d26-48f1-8c50-99b8f17ac779",
                        "name": "Consegue nadar distâncias maiores (definidas pela escola) mantendo técnica e ritmo.",
                        "order": 5,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "891c2158-96c0-41c4-94ae-c692b4882483",
                "name": "Nado costas – aperfeiçoamento",
                "order": 2,
                "xp": 4,
                "topics": [
                    {
                        "id": "2e093508-f2a5-44bf-b692-6f801a586c26",
                        "name": "Mantém quadril alto, próximo à superfície, evitando \"sentar\" na água.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "d7d84d7f-c4b1-4c33-9131-7c29fe70613f",
                        "name": "Realiza braçada de costas com trajetória completa (entrada com dedo mínimo, puxada forte, recuperação relaxada).",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "4bab3728-2e89-42c9-8747-f0e31704b6ba",
                        "name": "Mantém rotação de ombros/tronco, facilitando braçada e respiração.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "6a35f0c5-dc9d-4b1e-9f98-5b508e78a298",
                        "name": "Coordena pernada e braçada de costas de forma contínua em toda a raia.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "235a17dc-4ea5-4aa8-9739-ae696e54ed11",
                "name": "Nado peito – pernada",
                "order": 3,
                "xp": 6,
                "topics": [
                    {
                        "id": "a2034d8d-439f-4417-8a32-c7c08dd2d114",
                        "name": "Executa pernada de peito com sequência correta: flexionar, abrir/empurrar e estender.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "8d787af8-1e3c-4c55-a600-e0203422bd5c",
                        "name": "Mantém pés em posição de \"pato\" (eversão), empurrando a água para trás.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "7995b880-0592-47ea-b93e-ce7d5d59cb6f",
                        "name": "Realiza pernada de peito com prancha, mantendo deslocamento constante.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "a51e88f8-3325-47f3-87d3-fa820bb77061",
                        "name": "Faz pernada de peito sem prancha, mantendo corpo alinhado e quadril próximo à superfície.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "e63780ac-e30e-4992-bfb6-8b7eb07c08c2",
                "name": "Nado peito – braçada",
                "order": 4,
                "xp": 12,
                "topics": [
                    {
                        "id": "a4662cf5-d2fe-4bfa-aaff-b22595d50087",
                        "name": "Faz braçada de peito com amplitude adequada: abre, puxa e junta as mãos à frente.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "878ea83b-f35e-4b20-80b8-7b2cf5c53796",
                        "name": "Mantém cotovelos altos durante a puxada, aproveitando melhor a força da água.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "930ea062-be10-436c-ada4-45567fd12530",
                        "name": "Puxa a água até a linha do peito e projeta os braços à frente em deslize alongado.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "5519f7cd-bb0b-4c70-8c42-0f2dabcbb786",
                        "name": "Coordena braçada de peito com respiração, levantando a cabeça no momento certo e retornando rapidamente ao alinhamento.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "7b034c8c-9dd3-4792-81df-c6047198bfb9",
                "name": "Nado peito – coordenação completa",
                "order": 5,
                "xp": 10,
                "topics": [
                    {
                        "id": "2ec8ddd0-c331-42b5-a5b2-21770f00c6a6",
                        "name": "Coordena a sequência do peito: braçada + respiração → pernada → deslize.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "4d1ccbbb-a724-4e7d-ad38-280d82111c59",
                        "name": "Mantém ritmo constante de ciclos, sem \"parar\" no meio do movimento.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "28581ebe-f502-4908-ac67-1ebca85f6b08",
                        "name": "Consegue nadar distâncias definidas pela escola fazendo peito completo com boa técnica.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "050ce5ab-2692-4f8c-b242-106ce5ff73a7",
                        "name": "Ajusta o tamanho do deslize de acordo com o objetivo (economizar energia ou aumentar a velocidade).",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "86e1615d-735a-4258-b3d1-73a42f8baf0e",
                "name": "Filipina (pullout do peito)",
                "order": 6,
                "xp": 12,
                "topics": [
                    {
                        "id": "86090d4c-ef28-4aa0-916b-2f3073a5d9d8",
                        "name": "Após saída ou virada, mantém corpo bem alinhado em flecha submersa.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "423e161c-fd5e-484f-94af-04c35ae3a83f",
                        "name": "Executa puxada submersa longa de peito (braçada para baixo e para trás), seguida de recuperação dos braços à frente.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "345530bc-38eb-45c9-9490-cc378a324f6f",
                        "name": "Executa uma pernada de peito após a puxada submersa, antes de emergir.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "57c74657-6529-43b1-83d7-d822aa2cf151",
                        "name": "Conecta a filipina aos primeiros ciclos de nado peito na superfície.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "90c58a2e-9805-41af-bc7f-b6d355c80982",
                "name": "Virada olímpica em crawl e costas",
                "order": 7,
                "xp": 12,
                "topics": [
                    {
                        "id": "0d7d81b6-6f9a-4444-98b5-612337b1b398",
                        "name": "Em crawl, aproxima-se da borda contando braçadas, executa a cambalhota e empurra a parede em flecha ventral.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "77a55e33-9a7e-4f16-8f4d-71c58fab0328",
                        "name": "Ajusta a distância para não bater na parede nem ficar longe demais antes da cambalhota.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "93ddd79f-e15d-459f-90c1-010e8a6d49f4",
                        "name": "Em costas, aprende sequência: rotação para ventral, cambalhota próxima à parede e impulso em flecha dorsal.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "264dc9b8-6fb4-421e-a774-3cb00bd19a4f",
                        "name": "Conecta a virada ao retorno do nado, recuperando a velocidade rapidamente.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "5f7507e1-9ffe-4323-8234-0bbb2b2a9f8e",
                "name": "Virada e chegada de peito",
                "order": 8,
                "xp": 4,
                "topics": [
                    {
                        "id": "b350cfb0-e1c1-4330-88bf-19f4397c6d72",
                        "name": "Aproxima-se da borda em peito e executa virada com toque simultâneo das duas mãos.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "62364b03-f033-4c49-a2bc-04fd453f4925",
                        "name": "Após o toque duplo, recolhe pernas, gira o corpo, coloca os pés na parede e impulsiona.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "ccb8744d-3386-45ae-9df9-774bc03bc5d9",
                        "name": "Aplica a filipina após a virada, voltando ao nado na superfície.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "aebca4bd-d0fe-456d-8308-a9c781fd11e6",
                        "name": "Na chegada, mantém o nado até a borda e finaliza com toque firme das duas mãos ao mesmo tempo.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "5fce8b85-a35e-4dce-bb66-10e42cb065dc",
                "name": "Chegadas – crawl e costas",
                "order": 9,
                "xp": 2,
                "topics": [
                    {
                        "id": "155f3ce0-0a5e-4dee-b033-e029b8670270",
                        "name": "Em crawl, termina o percurso tocando a borda com a mão, sem parar antes e, se possível, sem respirar nos últimos instantes.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "54230905-d884-436f-9deb-5ae69189dea3",
                        "name": "Em costas, regula a aproximação pela contagem de braçadas, mantendo o nado até o toque, sem virar de bruços antes da chegada.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            }
        ]
    },
    {
        "color": "#ffb2b2",
        "name": "Estágio 4",
        "searchName": "estagio 4",
        "description": "Equipe dos Tubarões! 🦈 Onde a mágica acontece. A turminha domina os 4 estilos, incluindo o poderoso nado Borboleta! Descobrem os truques dos campeões para largadas de foguete, viradas perfeitas e aprendem que o esporte é sobre superação pessoal e muito respeito aos amigos.",
        "order": 5,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 82,
        "value": 0,
        "objectives": [
            {
                "id": "14537a6a-6fd8-4e14-8407-366ef10ddc8e",
                "name": "Nado crawl – aperfeiçoamento técnico e ritmo",
                "order": 1,
                "xp": 4,
                "topics": [
                    {
                        "id": "0e71d2a4-a2fc-4e0a-8f33-cf38b4e2d3c7",
                        "name": "Mantém alinhamento corporal, minimizando movimentos desnecessários.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "8262b7f5-c606-4ea7-8d50-b83899c57597",
                        "name": "Ajusta o tamanho da braçada para aproveitar mais cada ciclo e dar menos braçadas por piscina.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "3cf32f51-22e0-4264-ab4c-d367af90f8fe",
                        "name": "Mantém pernada contínua, usando-a para estabilizar e acelerar quando necessário.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "88b9d9b5-b986-499c-99b6-277543f462fd",
                        "name": "Controla o ritmo: sabe nadar mais \"solto\" (leve) e mais \"forte\" (rápido) mantendo técnica.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "a8f63ce8-2b8e-409e-8f75-a030ca20fc1e",
                "name": "Nado costas – controle de direção e eficiência",
                "order": 2,
                "xp": 4,
                "topics": [
                    {
                        "id": "6eda89b7-e8b3-4532-8709-5dca4d9bf857",
                        "name": "Mantém o corpo alinhado, evitando desviar para as raias vizinhas.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "f333bc61-57d6-475c-a3de-c1a33de92720",
                        "name": "Regula a rotação de tronco para facilitar braçada e respiração sem exagero.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "5c3f7d26-7792-4387-81b8-b268853c24ba",
                        "name": "Aperfeiçoa a braçada, buscando entrada suave, pegada forte e recuperação relaxada.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "af52ef63-ff28-47fb-9ae8-f88829bd115a",
                        "name": "Ajusta a contagem de braçadas após a bandeira para chegar bem à parede nas viradas e chegadas.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "67b4d37f-57fc-487f-babe-9b7e5af0a5a5",
                "name": "Nado peito – refinamento da técnica",
                "order": 3,
                "xp": 8,
                "topics": [
                    {
                        "id": "44f05116-da47-4bd2-bfb3-2e6b0ba474bb",
                        "name": "Ajusta a amplitude da pernada de peito para ser eficiente, sem abrir demais nem encurtar.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "4907ad08-c085-42d4-9fed-e97d4bece3e4",
                        "name": "Aperfeiçoa a braçada, trazendo água com força até o peito e projetando braços à frente em deslize alongado.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "cef2fe11-fb18-4b55-abcc-313df3ce3ad4",
                        "name": "Mantém sequência correta (braçada + respiração → pernada → deslize) com ritmo constante.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "e69c1592-26ed-49f9-a4f9-c2aebce485e7",
                        "name": "Controla o tamanho do deslize conforme o objetivo (economia de energia x velocidade).",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "e9abcd6d-3f7b-404a-8076-07cd46dd3439",
                "name": "Pernada de borboleta – consolidação",
                "order": 4,
                "xp": 9,
                "topics": [
                    {
                        "id": "66fbc799-5ead-48a3-a975-8441b45a55e6",
                        "name": "Mantém ondulação partindo do tronco/quadril, evitando dobrar apenas os joelhos.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "68ae1507-0edb-415f-9444-fcdb9d073333",
                        "name": "Realiza duas pernadas por ciclo de braçada, sentindo o \"embalo\" da ondulação.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "1ecc8e78-e2ca-4ccc-978f-9a48f02c3038",
                        "name": "Mantém pernada de borboleta em séries curtas sem quebrar o ritmo nem afundar demais.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "9c4add5f-876f-49b2-bcca-34b92a775f6f",
                "name": "Braçada de borboleta",
                "order": 5,
                "xp": 12,
                "topics": [
                    {
                        "id": "9992acaa-ea1f-4106-9e7a-2c39c184225b",
                        "name": "Realiza braçada simultânea, entrando com as mãos à frente dos ombros.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "0146a895-87a3-457f-9256-561c146f8adb",
                        "name": "Puxa a água abaixo do peito e finaliza ao lado das coxas antes da recuperação aérea.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "574f7592-1ff5-41a3-892e-f5c33d6f312b",
                        "name": "Mantém cotovelos relativamente altos na puxada, evitando \"braçada rasa\".",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "b8f815a8-3427-494c-b071-0f8d58b70f39",
                        "name": "Faz recuperação aérea com braços relaxados, por cima da água, com boa amplitude.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "7d9b677d-3665-4134-92d8-384fe3cac9a6",
                "name": "Borboleta completo – coordenação e respiração",
                "order": 6,
                "xp": 8,
                "topics": [
                    {
                        "id": "d76e7da0-d481-4d4c-aad6-0fe25a7464e2",
                        "name": "Coordena o ciclo do borboleta: pernada → braçada + respiração → pernada → deslize.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "bf0d528d-5a2f-4761-aa2c-166353ddd93b",
                        "name": "Respira para frente sem levantar demais a cabeça, mantendo o olhar levemente à frente.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "08559aa9-53fc-4b38-aba2-c23f56ecb648",
                        "name": "Consegue nadar pequenas distâncias (definidas pela escola, ex.: 12,5 m) com borboleta completo, mantendo ritmo.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "f3b215b2-74d0-4e10-82e0-6b5d437a19fb",
                        "name": "Diferencia borboleta de aquecimento (mais leve) e borboleta forte (mais potente), sem perder a técnica.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "94805130-ab8e-4e43-a923-e9cd73450fbd",
                "name": "Medley – ordem dos estilos e transições",
                "order": 7,
                "xp": 6,
                "topics": [
                    {
                        "id": "54de1d8e-20ff-4024-8f2c-16a7667e42df",
                        "name": "Conhece a ordem do medley individual: borboleta → costas → peito → crawl.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "d363d923-d147-4be4-953a-bc3332155392",
                        "name": "Conhece a ordem do revezamento medley, se a escola utilizar: costas → peito → borboleta → crawl.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "3f8a3a2d-662d-405d-b3f7-3cd418d9b992",
                        "name": "Entende a lógica das transições: como terminar corretamente um estilo e iniciar o próximo.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "12ecca15-63c7-4a88-b2d0-aa244c17c998",
                        "name": "Realiza pequenos medleys (ex.: 4 x 12,5 m, um de cada estilo) com pausas, para aprender a sequência.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            },
            {
                "id": "85b96f10-fa6b-4cdc-9de4-88c4e1e5065a",
                "name": "Viradas específicas de medley e borboleta",
                "order": 8,
                "xp": 12,
                "topics": [
                    {
                        "id": "c08fc12c-4c0a-4c75-ac66-44d667b71b60",
                        "name": "Em borboleta, executa virada com toque simultâneo das duas mãos, seguido de giro e impulso em flecha.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "688c0529-a35f-4c64-a8b0-3a3540e0c8e6",
                        "name": "Na transição borboleta → costas, finaliza com toque correto e gira para sair em decúbito dorsal.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "013d7b71-3f31-4342-b69f-20894096f589",
                        "name": "Na transição costas → peito, realiza virada específica (rotação controlada, toque/empurrão e saída ventral).",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "dfa3c52b-96cd-4cd6-b33b-cada62816efc",
                        "name": "Na transição peito → crawl, toca com as duas mãos, organiza o corpo e sai em flecha para o crawl.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "5cd83dbd-b1ce-4992-b741-d03fab7ee97e",
                "name": "Saídas e chegadas em todos os estilos",
                "order": 9,
                "xp": 15,
                "topics": [
                    {
                        "id": "b03ae966-235b-490b-96d2-1675c60d210f",
                        "name": "Aperfeiçoa largadas em pé (para borboleta, peito e crawl), buscando maior distância de voo e entrada hidrodinâmica.",
                        "order": 1,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "682097eb-5d6a-4847-9aed-2e7de98696ef",
                        "name": "Mantém posição streamline firme após a entrada, aproveitando o deslize.",
                        "order": 2,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "fa635d47-c4f2-4a28-aecd-7f291d6fba75",
                        "name": "Em crawl e borboleta, pratica chegadas fortes, mantendo o nado até bater a mão na borda.",
                        "order": 3,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "3c79464a-3c36-46dc-bca3-bb34e0e6e6ad",
                        "name": "Em costas, regula a contagem a partir das bandeiras para chegar com a braçada certa, sem frear antes da parede.",
                        "order": 4,
                        "xp": 3,
                        "isFundamental": true
                    },
                    {
                        "id": "4d08b84f-dde8-4946-88cc-9934ffd61c88",
                        "name": "Em peito, garante que o toque final seja sempre com as duas mãos simultâneas.",
                        "order": 5,
                        "xp": 3,
                        "isFundamental": true
                    }
                ]
            },
            {
                "id": "7ab1767f-b880-4ae8-beef-075bc60b3ed9",
                "name": "Ritmo de prova e consciência tática",
                "order": 10,
                "xp": 4,
                "topics": [
                    {
                        "id": "98a13690-f1ae-4ca5-af5a-01a3ac4cd960",
                        "name": "Aprende a diferenciar aquecimento, ritmo moderado e ritmo forte.",
                        "order": 1,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "5687632e-d84b-4901-a0c9-21ed07b5739f",
                        "name": "Experimenta nadar \"negativo\": começar mais leve e terminar mais forte, sem perder a técnica.",
                        "order": 2,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "2b2a2728-3d4d-4727-b382-b19e908e147a",
                        "name": "Passa a ter noção de quantas piscinas e quantas braçadas faz em cada trecho.",
                        "order": 3,
                        "xp": 1,
                        "isFundamental": false
                    },
                    {
                        "id": "473d909b-f464-4813-b90b-59e24b50b7ff",
                        "name": "Entende que provas e festivais são momentos de diversão, superação pessoal e respeito aos colegas.",
                        "order": 4,
                        "xp": 1,
                        "isFundamental": false
                    }
                ]
            }
        ]
    },
    {
        "color": "#3b82f6",
        "name": "Natação Adulto",
        "searchName": "natacao adulto",
        "description": "Atividade voltada para o desenvolvimento em Natação Adulto. Níveis e tópicos específicos ainda serão definidos.",
        "order": 6,
        "status": "active",
        "evaluationSystem": true,
        "hasEvaluation": true,
        "xp": 0,
        "value": 0,
        "objectives": []
    },
    {
        "color": "#18bf4a",
        "name": "Hidroginástica",
        "searchName": "hidroginastica",
        "description": "Atividade voltada para o desenvolvimento em Hidroginástica. Níveis e tópicos específicos ainda serão definidos.",
        "order": 7,
        "status": "active",
        "evaluationSystem": false,
        "hasEvaluation": false,
        "xp": 0,
        "value": 0,
        "objectives": []
    },
    {
        "color": "#91a1ba",
        "name": "Nado livre",
        "searchName": "nado livre",
        "description": "",
        "order": 8,
        "status": "active",
        "evaluationSystem": false,
        "hasEvaluation": false,
        "xp": 0,
        "value": 0,
        "objectives": []
    }
];
